/*eslint-disable*/
import React, { Component } from 'react'
import { Table, Header, Container, Segment, Dropdown, Input, Button, Icon } from 'semantic-ui-react'
import { Field } from 'formik'
import SerialNumber from '../../apiInputComponent/serialNumber'
import ProductName from '../../apiInputComponent/getProductNames'
import { MyInput, MyNormalInput } from '../../apiInputComponent/myInput'

export default class ProductDetailsInfo extends Component {

    state = {
        productsUpdate: [],
        subAmt: 0,
        getrLoad: false,
        discountType: false,
    }

    componentDidMount() {
        let info = this.props.getProductInfo
        let products = []
        let subtotals = []
        info.map((object) => {
            products.push(object.jb_product_services)
            object.jb_product_services.map((o) => {
                subtotals.push(o.totalAmt)
            })
        })
        let reducer = (accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue);
        this.setState({
            productsUpdate: products[0],
            subAmt: subtotals.length !== 0 ? subtotals.reduce(reducer) : 0
        })
    }
    getLoading = (childData) => {
        if (childData) {
            this.setState({
                getrLoad: true
            })
            setTimeout(() => {
                this.setState({
                    getrLoad: false
                })
            }, 100);
        }
    }
    handleIncrease = () => {
        var tempArr = { 'psId': '', 'quantity': '', 'rate': '', 'discount': '', 'discountType': 'R', 'gstAmount': '', 'gstPercentage': '', 'totalAmt': '' }

        this.setState({
            productsUpdate: [...this.state.productsUpdate, tempArr]
        })
    }
    handleDecrease = (e, data) => {
        // console.log('>>', data)
        let id = data.dataId
        let lists = this.state.productsUpdate;
        lists.splice(id, 1)
        this.setState({
            productsUpdate: [...lists]
        })
    }
    handleProductChange = (e, data) => {
        let name = data.name
        if (name === 'quantity') {
            if (!data.value.match(/^([0-9])+$/)) {
                let tempAddProduct = this.state.productsUpdate;
                tempAddProduct[data.dataId].quantity = 0
                tempAddProduct[data.dataId].gstPercentage = data.dataValue;
                tempAddProduct[data.dataId].gstAmount = 0;
                this.setState({
                    productsUpdate: [...tempAddProduct]
                })
                this.calc(data.dataId)
            } else {
                let tempAddProduct = this.state.productsUpdate;
                tempAddProduct[data.dataId].quantity = data.value
                tempAddProduct[data.dataId].gstPercentage = data.dataValue;
                tempAddProduct[data.dataId].gstAmount = data.dataGst;
                this.setState({
                    productsUpdate: [...tempAddProduct]
                })
                this.calc(data.dataId)
            }
        }

    }
    calc = (inx) => {
        let tempAddProduct = this.state.productsUpdate;
        let stagedProduct = tempAddProduct[inx];
        let rate = tempAddProduct[inx].rate
        let quantity = tempAddProduct[inx].quantity
        let discount = tempAddProduct[inx].discount
        let gstAmount = tempAddProduct[inx].gstAmount
        let gstPercentage = tempAddProduct[inx].gstPercentage
        let discountAmount = 0
        let totalCost = rate * quantity
        let gstAmountNew = ((totalCost * gstPercentage) / 100)
        let amount = totalCost + gstAmountNew
        if (tempAddProduct[inx].discountType === 'P') {
            discountAmount = (amount * discount) / 100
        } else {
            discountAmount = discount
        }
        let totalAmount = amount - discountAmount
        tempAddProduct[inx].gstAmount = gstAmountNew
        tempAddProduct[inx].totalAmt = totalAmount
        this.setState({
            productsUpdate: [...tempAddProduct]
        })
    }
    handleProductdiscount = (e, data) => {
        let name = data.field.name
        let gstAmounts = data.dataValue
        if (name === 'discount') {
            if (data.value.match(/^([0-9])+$/)) {
                let tempAddProduct = this.state.productsUpdate;
                tempAddProduct[data.dataId].discount = data.value;
                tempAddProduct[data.dataId].gstAmount = gstAmounts;
                this.setState({
                    productsUpdate: tempAddProduct
                })
                this.calc(data.dataId)

            } else {
                let tempAddProduct = this.state.productsUpdate;
                tempAddProduct[data.dataId].discount = 0;
                tempAddProduct[data.dataId].gstAmount = gstAmounts;
                this.setState({
                    productsUpdate: tempAddProduct
                })
                this.calc(data.dataId)

            }

        }

    }
    handleDiscount = (e, data) => {
        if (data.value === 'P') {
            let tempAddProduct = this.state.productsUpdate;
            tempAddProduct[data.dataId].discountType = data.value
            this.setState({
                productsUpdate: [...tempAddProduct],
                discountType: true
            })
            this.calc(data.dataId)
        }
        if (data.value === 'R') {
            let tempAddProduct = this.state.productsUpdate;
            tempAddProduct[data.dataId].discountType = data.value
            this.setState({
                productsUpdate: [...tempAddProduct],
                discountType: false
            })
            this.calc(data.dataId)
        }
    }

    render() {
        const { productsUpdate } = this.state
        const options = [
            { key: '1', text: '₹', value: 'R' },
            { key: '2', text: '%', value: 'P' },
        ]
        const { editable } = this.props
        productsUpdate.sum = function (prop) {
            var total = 0
            for (var i = 0, _len = this.length; i < _len; i++) {
                total += this[i][prop]
            }
            return total
        }
        // console.log(parseFloat(this.state.productsUpdate.sum('totalAmt')))
        return (
            <React.Fragment>
                <Table hidden={this.props.hideDiv} unstackable className="w3-small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan="8"><Header as="label" size="small" className="p-bold-500" color="blue">Product/Service Details</Header></Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                            <Table.HeaderCell className="labelName p-bold-600">Product/Service Details</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">GST(%)</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">GST Amount</Table.HeaderCell>
                            <Table.HeaderCell colSpan="2" textAlign="right" className="labelName p-bold-600">Amount</Table.HeaderCell>
                            {/* <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell> */}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {productsUpdate.map((o, i) => (
                            <>
                                <Table.Row>
                                    <Table.Cell>{this.props.onlyDisplay ? o.psName : <Field dataId={i} disabled className="disabledField" component={ProductName} value={o.psId} name="psId" getLoad={this.getLoading} productState={this.state.productsUpdate} />} </Table.Cell>
                                    <Table.Cell>
                                        {this.props.onlyDisplay ? <div className="mt-2">{`${o.quantity}`}</div> : <Field dataId={i} type="number" min="0" component={MyNormalInput} autoComplete="off" value={o.quantity} name="quantity" onChange={this.handleProductChange} dataGst={this.gstAmount} dataValue={o.gstPercentage} />}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.props.onlyDisplay ? <div className="mt-2">{`${o.rate}`}</div> : <Field value={o.rate} component={MyNormalInput} readOnly dataId={i} />}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.props.onlyDisplay ? <div className="mt-2">{`${o.discount} ${o.discountType === 'P' ? '%' : "₹"}`}</div> : <Field style={{ width: '30%' }} readOnly min="0" dataId={i} type="number" value={o.discount} component={Input} name="discount" dataValue={this.gstAmount} onChange={this.handleProductdiscount}
                                            label={<Dropdown disabled placeholder={o.discountType === 'P' ? '%' : "₹"} dataId={i} options={options}
                                                onChange={this.handleDiscount} />} labelPosition="right" className="tableinput" />}
                                    </Table.Cell>
                                    <Table.Cell dataId={i}>
                                        <div className="mt-2">{o.gstPercentage ? `${o.gstPercentage}%` : '0%'}</div>
                                    </Table.Cell>
                                    <Table.Cell dataId={i}><div className="mt-2">{o.gstAmount ? o.gstAmount : '0'}</div></Table.Cell>
                                    <Table.Cell colSpan="2" dataId={i} textAlign="right"><div className="mt-2">{o.totalAmt}</div></Table.Cell>
                                    <Table.Cell hidden textAlign="right"><Button dataId={i} onClick={this.handleDecrease} type="button" hidden={i === 0 ? true : false} size="mini" color="red" basic icon><Icon name="trash" /></Button></Table.Cell>
                                </Table.Row>
                            </>
                        ))}
                        {/* <Table.Row>
                            <Table.Cell colSpan="7">
                                <Button type="button" onClick={this.handleIncrease} size="mini" basic color="blue"> + Add Product</Button>
                            </Table.Cell>
                        </Table.Row> */}
                        <Table.Row>
                            <Table.Cell colSpan="6" className="p-bold-600">SubTotal</Table.Cell>
                            <Table.Cell colSpan="2" className="p-bold-600" textAlign="right">
                                {this.state.subAmt}
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell colSpan="6" className="p-bold-600">Adjustment Amount</Table.Cell>
                            <Table.Cell hidden={editable} className="p-bold-600">
                                {this.props.onlyDisplay ? '' : <Field hidden={editable} component={MyNormalInput} autoComplete="off" min="0" type="number" name="adjustAmt" />}
                            </Table.Cell>
                            <Table.Cell className="p-bold-600" textAlign="right">
                                <div className="mt-2"> {this.props.getProductInfo[0].adjustmentAmt}</div>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell colSpan="6" className="p-bold-600">Total</Table.Cell>
                            <Table.Cell colSpan="2" className="p-bold-600" textAlign="right">{this.props.getProductInfo[0].totalAmt}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </React.Fragment>
        )
    }
}
